import { render, staticRenderFns } from "./POSInput.vue?vue&type=template&id=1cc04eea&scoped=true"
import script from "./POSInput.vue?vue&type=script&lang=js"
export * from "./POSInput.vue?vue&type=script&lang=js"
import style0 from "./POSInput.vue?vue&type=style&index=0&id=1cc04eea&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc04eea",
  null
  
)

export default component.exports